/**
 * Tailwind CSS breakpoint values in pixels.
 * These match the default Tailwind breakpoints with custom 2xl override.
 *
 * @see https://tailwindcss.com/docs/responsive-design
 */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1400,
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;
